export function createLogger(scope, debug = false) {
  const prefix = `[${scope}]`;

  return {
    always(...args) {
      console.log(prefix, ...args);
    },

    warn(...args) {
      console.warn(prefix, ...args);
    },

    error(...args) {
      console.error(prefix, ...args);
    },

    debug(...args) {
      if (!debug) return;
      console.log(`${prefix}[debug]`, ...args);
    },
  };
}

export function getDebugMode(container) {
  const dataValue = container?.dataset?.debugMode;
  const attrValue = container?.getAttribute?.("debug-mode");
  const value = (dataValue ?? attrValue ?? "").toString().toLowerCase().trim();

  return value === "1" || value === "true" || value === "yes" || value === "on";
}

export const PLAYER_LOG_EVENTS = {
  PLAYER_LOADED: "PLAYER_LOADED",
  CONFIG_LOADED: "CONFIG_LOADED",
  REVIVE_RESPONSE_RECEIVED: "REVIVE_RESPONSE_RECEIVED",
  WATERFALL_STARTED: "WATERFALL_STARTED",

  REQUEST_ATTEMPT: "REQUEST_ATTEMPT",
  REQUEST_SENT: "REQUEST_SENT",
  RESPONSE_RECEIVED: "RESPONSE_RECEIVED",
  NO_AD: "NO_AD",
  TIMEOUT: "TIMEOUT",

  NEXT_PROVIDER_CALLED: "NEXT_PROVIDER_CALLED",
};

export function logPlayerEvent(log, event, data = {}) {
  log.debug(`[PlayerEvent] ${event}`, {
    event,
    ts: Date.now(),
    ...data,
  });
}